export const fetchUserCoursesIds = `
query FetchUserCoursesIds {
    me {
      courses {
        postid
      } 
    }
  }
  
`